lazyLoadMerchantLocations = window.lazyLoadMerchantLocations ?= {}

window.GMap ?= {}

lazyLoadMerchantLocations.reload = (data) ->
  {merchantHtml, merchantModalHtml, touchRequest} = data

  if merchantHtml.length
    if GMap.isLoaded
      GMap.init data, ->
    else
      GMap.asyncMapData = data

  if not touchRequest and merchantModalHtml.length
    GIG?.Modal?.reloadBindings(el=document.body, unbindFirst=false)

lazyLoadMerchantLocations.ajax_success = (data) ->
  return unless data

  {dealTitleMerchantInfoHtml, merchantHtml, merchantModalHtml, touchRequest} = data

  if merchantHtml.length
    $('#merchant-locations-placeholder').replaceWith merchantHtml
  else
    $('#merchant-locations-placeholder').remove()

  if dealTitleMerchantInfoHtml.length
    $('#deal-subtitle-container').replaceWith dealTitleMerchantInfoHtml
    GIG?.Tooltip?.reloadBindings('.deal-subtitle')

  if touchRequest
    if merchantModalHtml.length
      $('.t-main').after merchantModalHtml
  else
    # add tooltips and modals potentially together (one less re-paint)

    $tooltipAndModalData = ""
    if _.isString merchantModalHtml
      $tooltipAndModalData += merchantModalHtml

    if $tooltipAndModalData.length
      $lastTooltip = $('.tooltip').last() or $('section.main')
      $lastTooltip.after $tooltipAndModalData

  lazyLoadMerchantLocations.reload(data)

lazyLoadMerchantLocations.init = (payload, done) ->
  {clientSideMerchantLocations} = payload

  unless clientSideMerchantLocations?
    return done()

  $.ajax
    url      : clientSideMerchantLocations.formattedUrl
    dataType : 'json'
    success  : lazyLoadMerchantLocations.ajax_success
    error: (err) ->
      $('#merchant-location-placeholder').remove()

  done()

module.exports = lazyLoadMerchantLocations
